import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as _ from 'underscore';
import * as MicroUtils from '../../utils';
import { env } from '@ivy/fts/envInfo/envInfo';
import { translateUrl } from '@/api/goods/statistics';
let vm = null;
let Picture = class Picture extends Vue {
    constructor() {
        super(...arguments);
        this.showDesc = false;
        this.ruleAndLoopFn = _.debounce(this.resetLoop, 300);
        this.pictureClass = 'one-line';
        this.loopKey = 1111;
        this.nextColor = 1;
        this.swiperOption = {
            pagination: {
                el: '.swiper-pagination',
            },
            //设置点击箭头
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            //自动轮播
            // autoplay: true,
            autoplay: {
                delay: 3000,
                //当用户滑动图片后继续自动轮播
                disableOnInteraction: false,
            },
            //开启循环模式
            loop: true,
            // 版本过低不生效
            observe: true,
            observeParents: true,
            effect: 'slide',
            on: {
                click() {
                    let attrs = this.clickedSlide.attributes || {};
                    let url = attrs['data-jump-url'] ? attrs['data-jump-url'].nodeValue : '';
                    let i = attrs['data-swiper-slide-index']
                        ? +attrs['data-swiper-slide-index'].nodeValue
                        : 0;
                    let imgName = attrs['data-desc']
                        ? attrs['data-desc'].nodeValue || `图片${i + 1}`
                        : `图片${i + 1}`;
                    let hasAuth = attrs['data-has-auth']
                        ? attrs['data-has-auth'].nodeValue
                        : false;
                    console.log(url, imgName, hasAuth);
                    if (url && hasAuth === '1') {
                        vm.goLink(url, imgName);
                    }
                },
            },
        };
    }
    templateChange(newV) {
        this.pictureClass = newV + '-line';
    }
    marginChange(newV) {
        if (this.data.lineRule === 'loop') {
            this.ruleAndLoopFn();
        }
    }
    lengthChange(newV) {
        if (this.data.lineRule === 'loop') {
            this.ruleAndLoopFn();
        }
    }
    get isLoopImgs() {
        return this.data.lineRule === 'loop';
    }
    get noticeStyle() {
        return {
            color: this.data,
            background: this.data.bgColor,
        };
    }
    get compStyle() {
        if (this.isLoopImgs) {
            return {
                background: this.data.bgColor,
                padding: `0px ${MicroUtils.convertPxToVw(this.data.compMargin)}vw`,
            };
        }
        else {
            return {
                padding: `0px ${MicroUtils.convertPxToVw(this.data.compMargin)}vw`,
                background: this.nextColor ? this.data.bgColor : this.data.bgColor,
                'margin-left': `-${MicroUtils.convertPxToVw(this.data.spacing / 2)}vw`,
                'margin-right': `-${MicroUtils.convertPxToVw(this.data.spacing / 2)}vw`,
            };
        }
    }
    get pictureStyle() {
        return {};
    }
    get imgBoxStyle() {
        return {
            'border-radius': this.data.radius + 'px',
            margin: `${MicroUtils.convertPxToVw(this.data.spacing / 2)}vw`,
        };
    }
    get loopImgBoxStyle() {
        return {
            'border-radius': this.data.radius + 'px',
        };
    }
    get imgStyle() {
        if (this.data.openUserPoint) {
            return {
                'border-radius': this.data.radius + 'px',
            };
        }
        else {
            return {
                'border-radius': this.data.radius + 'px',
                'pointer-events': 'none',
            };
        }
    }
    get descStyle() {
        return {
        // 'border-radius': this.data.radius + 'px'
        };
    }
    created() {
        vm = this;
        this.pictureClass = this.data.lineRule + '-line';
    }
    async mounted() {
        await this.$nextTick();
        this.nextColor = 99;
    }
    // 轮播组件强制重新渲染
    resetLoop() {
        this.loopKey = Date.now();
    }
    // TODOswiper 组件在使用多个时，会共享 vm，会导致数据问题，需要重写
    async goLink(url, imgName) {
        if (!url || !this.data.has_auth)
            return;
        let translateRes = await translateUrl(url);
        // 微页面组件内容点击埋点
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: imgName,
            JumpType: translateRes.jumpType,
            JumpContentName: translateRes.jumpName,
            JumpContentID: translateRes.jumpId,
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        url && MicroUtils.goLink(url, env);
    }
};
tslib_1.__decorate([
    Prop()
], Picture.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], Picture.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Watch('data.lineRule') // 排列规则变化,多行
], Picture.prototype, "templateChange", null);
tslib_1.__decorate([
    Watch('data.compMargin') // 页面边距变化
], Picture.prototype, "marginChange", null);
tslib_1.__decorate([
    Watch('data.imgs.length') // 图片数据变化
], Picture.prototype, "lengthChange", null);
Picture = tslib_1.__decorate([
    Component({})
], Picture);
export default Picture;
